export enum ErrorCode {
  USER_ALREADY_SUBSCRIBED_ERROR = '403157',
  PARAMETERS_NOT_PROVIDED = '429003'
}
